import { Grid, useMediaQuery } from '@material-ui/core';
import React, { useState, useMemo, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
  DialogFormHLPure,
  DialogPrivacy,
  DialogSystemGLPure,
  GridSimpleReadHLPure,
  InputHLPure,
  Label,
  SimpleLoading,
} from '../../pures';
import { ArrowBtnMobile, LogoGovoLegal } from '../../../assets/logos/icons/index';
import './qr-signed-document.css';
import RenderMenu from '../../pures/adobePfdReader/PdfReader';
import { LogoColor } from '../../../assets/assets';
import Asn1DataTable from '../../pures/asn1Render/Asn1Render';

const QRSignedDocumentView = ({
  showLoadingRequesting,
  showCompletedRequesting,
  showErrorRequesting,
  toggleLoadingRequesting,
  toggleCompletedRequesting,
  toggleErrorRequesting,
  toggleWarningRequesting,
  showWarningRequesting,
  message,
  nameDocumentRequest,
  signType,
  hash,
  recordConservation,
  timeStamp,
  dataGrid,
  loading,
  proofOfLifeActive,
  documentGrid
}) => {
  const { t } = useTranslation();

  const [signerSelected, setSignerSelected] = useState({});
  const [modalTermsCond, setValidationForm] = useState(false);
  const [documentInfo, setDocumentInfo] = useState({})
  const [showDialog, setShowDialog] = useState(false)
  /** @type {[{url: string, name: string, generatedDate: string}, React.Dispatch<React.SetStateAction<{url: string, name: string, generatedDate: string}>]} */
  const [videoData, setVideoData] = useState({})
  /** @type {[{url: string, name: string, generatedDate: string}, React.Dispatch<React.SetStateAction<{url: string, name: string, generatedDate: string}>]} */
  const [photoData, setPhotoData] = useState({})
  const isMobile = useMediaQuery('(max-width:670px)')
  const [showType, setShowType] = useState('')
  const [openDocument, setOpenDocument] = useState(false)
  const is300 = useMediaQuery('(max-width:300px)')

  const pdf = useMemo(
    () => (
      <RenderMenu
        className='pdfReader'
        url={documentInfo.url}
        awsURL
      />
    ),
    [documentInfo.url]
  );

  useEffect(() => {
    if (documentGrid && documentGrid.length > 0) {
      const firstDoc = documentGrid[0]
      setShowType('document')
      setVideoData({})
      setPhotoData({})
      setDocumentInfo(firstDoc)
      setOpenDocument(true)
    }
  }, [documentGrid])


  const handleClickImg = () => {
    window.open('https://govo.digital/', '_blank');
  }

  const openModalTermsCond = (value) => {
    setValidationForm(value);
  };

  const showDocument = (dataItem) => {
    if (dataItem.docType === 'pdfFile' || dataItem.docType === process.env.REACT_APP_QR_SIGNED_FILE_TYPE_CONSTANCY) {
      setShowType('document')
      setVideoData({})
      setPhotoData({})
      setDocumentInfo(dataItem)
      setOpenDocument(true)
    } else if (dataItem.docType === process.env.REACT_APP_QR_SIGNED_FILE_TYPE_IMAGE || dataItem.docType === process.env.REACT_APP_QR_SIGNED_FILE_TYPE_IDENTITY_INE) {
      if (isMobile) setShowDialog(!showDialog)
      setOpenDocument(false)
      setShowType(process.env.REACT_APP_QR_SIGNED_FILE_TYPE_IMAGE)
      setPhotoData({ url: dataItem.url, name: dataItem.name, generatedDate: dataItem.date })
      setDocumentInfo({})
    } else if (dataItem.docType === process.env.REACT_APP_QR_SIGNED_FILE_TYPE_VIDEO) {
      if (isMobile) setShowDialog(!showDialog)
      setOpenDocument(false)
      setShowType(process.env.REACT_APP_QR_SIGNED_FILE_TYPE_VIDEO)
      setVideoData({ url: dataItem.url, name: dataItem.name, generatedDate: dataItem.date })
      setDocumentInfo({})
    } else if (dataItem.docType === process.env.REACT_APP_QR_SIGNED_FILE_TYPE_ASN1) {
      setVideoData({})
      setPhotoData({})
      setShowType(process.env.REACT_APP_QR_SIGNED_FILE_TYPE_ASN1)
      setDocumentInfo(dataItem)
      setOpenDocument(false)
    }
  }

  const PhotoRender = () => (
    <>
      <div style={{ marginBottom: '10px' }}>
        <span>{`Foto tomada durante la firma del documento el ${photoData.generatedDate}`}
        </span>
      </div>
      <img
        src={photoData.url}
        alt={photoData.name}
        className='qrSignedDocument-video-proofOfLife'
      />
    </>
  )

  const VideoRender = () => (
    <>
      <div style={{ marginBottom: '10px' }}>
        <span>{`Video grabado durante la firma del documento el ${videoData.generatedDate}`}
        </span>
      </div>
      <video
        className='qrSignedDocument-video-proofOfLife'
        controls
        playsInline
        muted
        preload='metadata'
        style={{ width: '100%' }}
        src={videoData.url}
      />
    </>
  )

  const mediaRender = useMemo(() => {
    if (showType === process.env.REACT_APP_QR_SIGNED_FILE_TYPE_IMAGE || showType === process.env.REACT_APP_QR_SIGNED_FILE_TYPE_IDENTITY_INE) {
      if (isMobile && !showDialog) return <></>
      return (
        <div>
          <PhotoRender />
        </div>
      )
    } else if (showType === process.env.REACT_APP_QR_SIGNED_FILE_TYPE_VIDEO) {
      if (isMobile && !showDialog) return <></>
      return (
        <div>
          <VideoRender />
        </div>
      )
    } else return <></>
  }, [videoData, photoData, showType])

  const govoLogo = `${process.env.REACT_APP_AWS_S3_BUCKET_URL}${process.env.REACT_APP_LOGO_COLOR}`

  return (
    <div className='qrSignedDocument-container'>
      {loading ? (
        <SimpleLoading />
      ) : (
        <>
          <div className='qrSignedDocument-container-header'>
            <img
              src={govoLogo}
              alt='Logo de govo.legal'
              style={{ height: '58px' }}
            />
          </div>
          <div className='qrSignedDocument-elements-container'>
            <Grid item lg={12} md={12} sm={12} es={12} xs={12}>
              <Label title={t('qrSignedDocument-label-document-signed')} />
            </Grid>
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              es={12}
              xs={12}
              className='qrSignedDocument-name-doc-container'
            >
              <InputHLPure
                labelInput={t('qrSignedDocument-label-document-name')}
                typeInput={'text'}
                disabled={true}
                tooltipShow={false}
                informationIcon={false}
                inputActive={true}
                valueInput={nameDocumentRequest}
              />
            </Grid>
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              es={12}
              xs={12}
              className='qrSignedDocument-typesigned-container'
            >
              <InputHLPure
                labelInput={t('qrSignedDocument.label.was.signed.with') + ' ' + signType}
                typeInput={'text'}
                disabled={true}
                tooltipShow={false}
                informationIcon={false}
                inputActive={false}
                readOnlyText={''}
              />
            </Grid>
            <Grid
              item
              className={'qrSignedDocument-grid'}
            >
              <div>
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  es={12}
                  xs={12}
                  className='digitalVaultView-data scroll'
                >
                  <GridSimpleReadHLPure
                    dataGrid={documentGrid}
                    skip={0}
                    take={documentGrid.length}
                    rowClick
                    onSelectedItem={() => { }}
                    titleRow1={'Archivo firmado'}
                    fieldRow1={'name'}
                    fieldSubtitle={'date'}
                    textSubtitle={'type'}
                    styleCol1={'qrSignedDocument-cellItemStyleCol1-document'}
                    handleIconArrow={showDocument}
                    columnFour={proofOfLifeActive}
                    columnFourCell={(props) =>
                      <td
                        className='qrSignedDocument-img-container-proofOfLife'
                        onClick={() => showDocument(props.dataItem)}
                      >
                        <img
                          className='qrSignedDocument-img-proofOfLife'
                          src={ArrowBtnMobile}
                        />
                      </td>
                    }
                    noRecordsElement={
                      <>
                        <p>{t('qrSignedDocument.noRecordsElement.title')}</p>
                        <span className='qrSignedDocument-noRecordsElement-desc'>{t('qrSignedDocument.noRecordsElement.description')}</span>
                      </>
                    }
                  />
                </Grid>
                <GridSimpleReadHLPure
                  dataGrid={dataGrid}
                  skip={0}
                  take={5}
                  // rowClick
                  titleRow1={t('qrSignedDocument-label-binnacle')}
                  fieldRow1={'name'}
                  fieldSubtitle={'date'}
                  textSubtitle={'type'}
                  styleCol1={'qrSignedDocument-cellItemStyleCol1'}
                  // handleIconArrow={proofOfLifeActive && handleClickGrid}
                  onSelectedItem={setSignerSelected}
                  filter={false}
                  column2Status={false}
                  // columnThree={proofOfLifeActive && !is1000Width}
                  styleCol3={'qrSignedDocument-cellItemStyleCol3'}
                  fieldRow3={'recognition'}
                  titleRow3={'Reconocimiento facial'}
                />
                {!isMobile &&
                  <>
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      es={12}
                      xs={12}
                      className='qrSignedDocument-hash-container'
                    >
                      <InputHLPure
                        labelInput={t('qrSignedDocument-label-hash')}
                        typeInput={'text'}
                        disabled={true}
                        tooltipShow
                        informationIcon={true}
                        positionTooltip={'right'}
                        titleTooltip={'Hash'}
                        descriptionTooltip={t('qrSignedDocument.hash.tooltip.description')}
                        inputActive={true}
                        valueInput={hash}
                      />
                    </Grid>
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      es={12}
                      xs={12}
                      className='qrSignedDocument-conservation-container'
                    >
                      <InputHLPure
                        labelInput={t('qrSignedDocument-record-conservation')}
                        typeInput={'text'}
                        disabled={true}
                        tooltipShow
                        informationIcon={true}
                        positionTooltip={'right'}
                        titleTooltip={t('qrSignedDocument-record-conservation')}
                        descriptionTooltip={t('qrSignedDocument.record.conservation.tooltip.description')}
                        inputActive={true}
                        valueInput={recordConservation}
                        specialCase={recordConservation === 'No aplica' ? true : false}
                      />
                    </Grid>
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      es={12}
                      xs={12}
                      className='qrSignedDocument-timestamp-container'
                    >
                      <InputHLPure
                        labelInput={t('qrSignedDocument-timestamp')}
                        typeInput={'text'}
                        disabled={true}
                        tooltipShow
                        informationIcon={true}
                        positionTooltip={'right'}
                        titleTooltip={t('qrSignedDocument-timestamp')}
                        descriptionTooltip={t('qrSignedDocument.timestamp.tooltip.description')}
                        inputActive={true}
                        valueInput={timeStamp}
                        specialCase={timeStamp === 'No aplica' ? true : false}
                      />
                    </Grid>
                  </>
                }
              </div>
              {documentInfo && documentInfo.url && showType === 'document' && openDocument && !isMobile && pdf}
              {documentInfo && documentInfo.asn1Data && showType === process.env.REACT_APP_QR_SIGNED_FILE_TYPE_ASN1 && !isMobile ? <Asn1DataTable data={[documentInfo.asn1Data]} /> : null}
              {!isMobile && mediaRender}
            </Grid>
            {documentInfo && documentInfo.url && showType === 'document' && openDocument && isMobile && pdf}
            {documentInfo && documentInfo.asn1Data && showType === process.env.REACT_APP_QR_SIGNED_FILE_TYPE_ASN1 && isMobile ? <Asn1DataTable data={[documentInfo.asn1Data]} /> : null}
            {isMobile &&
              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                es={12}
                xs={12}
                className='qrSignedDocument-input-container'
              >
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  es={12}
                  xs={12}
                  className='qrSignedDocument-hash-container'
                >
                  <InputHLPure
                    labelInput={t('qrSignedDocument-label-hash')}
                    typeInput={'text'}
                    disabled={true}
                    tooltipShow
                    informationIcon={true}
                    positionTooltip={'top'}
                    titleTooltip={'Hash'}
                    descriptionTooltip={t('qrSignedDocument.hash.tooltip.description')}
                    inputActive={true}
                    valueInput={hash}
                  />
                </Grid>
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  es={12}
                  xs={12}
                  className='qrSignedDocument-conservation-container'
                >
                  <InputHLPure
                    labelInput={t('qrSignedDocument-record-conservation')}
                    typeInput={'text'}
                    disabled={true}
                    tooltipShow
                    informationIcon={true}
                    positionTooltip={is300 ? 'left' : 'top'}
                    titleTooltip={t('qrSignedDocument-record-conservation')}
                    descriptionTooltip={t('qrSignedDocument.record.conservation.tooltip.description')}
                    inputActive={true}
                    valueInput={recordConservation}
                    specialCase={recordConservation === 'No aplica' ? true : false}
                  />
                </Grid>
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  es={12}
                  xs={12}
                  className='qrSignedDocument-timestamp-container'
                >
                  <InputHLPure
                    labelInput={t('qrSignedDocument-timestamp')}
                    typeInput={'text'}
                    disabled={true}
                    tooltipShow
                    informationIcon={true}
                    positionTooltip={'top'}
                    titleTooltip={t('qrSignedDocument-timestamp')}
                    descriptionTooltip={t('qrSignedDocument.timestamp.tooltip.description')}
                    inputActive={true}
                    valueInput={timeStamp}
                    specialCase={timeStamp === 'No aplica' ? true : false}
                  />
                </Grid>
              </Grid>
            }
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              es={12}
              xs={12}
              className='qrSignedDocument-conservation-container'
            >
              <a style={{ font: 'normal normal 600 14px Quicksand', color: '#427FBA' }}
                href='https://govo.digital'
                target='_blank'>
                {t('qrSignedDocument-label-use-govo')}
              </a>
            </Grid>
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              es={12}
              xs={12}
              className='qrSignedDocument-footer-img-container'
            >
              <button
                onClick={handleClickImg}
                className='qrSignedDocument-btn-img'
              >
                <img
                  alt='Logo de govo.legal footer'
                  src={LogoColor}
                  style={{ height: '58px' }}
                />
              </button>
            </Grid>
          </div>
          <Grid container justify='center' alignItems='center'>
            <div className='footer-register-person' item>
              <div className='footer-elements'>
                <div className='footer-textR-person'>
                  <h2>Powered by A3 Cloud Microservices, S.A.P.I. de C.V.</h2>
                </div>
                <div className='footer-textL-person'>
                  <h2
                    onClick={() => {
                      openModalTermsCond(true);
                    }}
                  >
                    Aviso de Privacidad
                  </h2>
                </div>
              </div>
            </div>
          </Grid>
          {(showDialog && isMobile) &&
            <DialogFormHLPure
              cancel={() => setShowDialog(false)}
              titleDialog={showType === process.env.REACT_APP_QR_SIGNED_FILE_TYPE_IMAGE ? `Foto de ${photoData.name}` : `Video de ${videoData.name}`}
            >
              {mediaRender}
            </DialogFormHLPure>
          }
          <DialogPrivacy
            openModalTermsCond={openModalTermsCond}
            modalTermsCond={modalTermsCond}
          />
          <DialogSystemGLPure
            showLoadingRequesting={showLoadingRequesting}
            showCompletedRequesting={showCompletedRequesting}
            showErrorRequesting={showErrorRequesting}
            toggleLoadingRequesting={toggleLoadingRequesting}
            toggleCompletedRequesting={toggleCompletedRequesting}
            toggleErrorRequesting={toggleErrorRequesting}
            toggleWarningRequesting={toggleWarningRequesting}
            showWarningRequesting={showWarningRequesting}
            message={message}
          />
        </>
      )}
    </div>
  );
};

export { QRSignedDocumentView as default };
